import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { IconComponent } from '@examdojo/core/icon';
import { PayoutRateHistoryComponent } from './payout-rate-history.component';

export interface PayoutRateHistoryDialogData {
  userId: string;
  userName?: string;
}

@Component({
  selector: 'dojo-payout-rate-history-dialog',
  standalone: true,
  imports: [MatDialogModule, IconComponent, PayoutRateHistoryComponent],
  template: `
    <div class="flex h-full flex-col">
      <div class="flex items-center justify-between border-b border-gray-200 px-6 py-4 dark:border-gray-700">
        <div class="flex items-center gap-3">
          <div
            class="flex h-10 w-10 items-center justify-center rounded-lg border border-sky-100 bg-sky-50 dark:border-sky-800 dark:bg-sky-900/20"
          >
            <dojo-icon [icon]="'clock-rotate-left'" [size]="20" class="text-sky-600 dark:text-sky-400" />
          </div>
          <div>
            <h2 class="text-base font-semibold text-gray-900 dark:text-gray-100">Hourly Rate History</h2>
            <p class="text-sm text-gray-500 dark:text-gray-400">View all historical rate changes</p>
          </div>
        </div>
        <button mat-dialog-close class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-gray-700">
          <dojo-icon [icon]="'times'" [size]="20" class="text-gray-500 dark:text-gray-400" />
        </button>
      </div>

      <div class="flex-1 overflow-auto p-6">
        <dojo-payout-rate-history [userId]="data.userId" [hideHeader]="true" />
      </div>
    </div>
  `,
  host: { class: 'block h-full' },
})
export class PayoutRateHistoryDialogComponent {
  readonly data = inject<PayoutRateHistoryDialogData>(MAT_DIALOG_DATA);
}
